// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserWebStorageInstance } from '../../user-web-storage';
import { BaseStorageManager } from '@shared/utils/Managers/BaseStorageManager';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { UserIndexedDB, UserIndexedDBStore } from '@shared/commons/DataBase/UserIndexedDB';
import { DynProperty } from '@shared/commons/DynProperty';
import { WDSettings } from '../settings/WDGeneralSettings';
import { CurrentLang } from '@shared/localizations/Resources';
class _WDSettingsStorageManager extends BaseStorageManager {
    onRestoreAsync(dynProperties) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((dynProperties === null || dynProperties === void 0 ? void 0 : dynProperties.length) > 0) {
                yield SessionSettings.applyNewSettingsAsync(dynProperties, true, CurrentLang);
            }
            else {
                WDSettings.reset();
            }
        });
    }
    serializeData() {
        return DynProperty.serialize(SessionSettings.Properties(true));
    }
    deserializeDataAsync(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.resolve(DynProperty.deserialize(data));
        });
    }
    fetchRemoteSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield UserWebStorageInstance.settings.get();
        });
    }
    sendRemoteSettings(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield UserWebStorageInstance.settings.post(data);
        });
    }
}
export const WDSettingsStorageManager = new _WDSettingsStorageManager(UserIndexedDB, UserIndexedDBStore.WD_SETTINGS);
